// bm-design-system: select primitive
import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  /**
   * Classes for the positioning wrapper rather than the `<select>` itself.
   *
   * Width belongs here. The chevron is absolutely positioned against this
   * wrapper, so narrowing the `<select>` alone through `className` leaves the
   * chevron stranded at the right edge of a full-width box.
   */
  wrapperClassName?: string;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, wrapperClassName, children, ...props }, ref) => {
    return (
      <div className={cn("relative", wrapperClassName)}>
        <select
          ref={ref}
          className={cn("form-control form-control-select", className)}
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          aria-hidden="true"
          className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted"
        />
      </div>
    );
  },
);
Select.displayName = "Select";

export { Select };
